import { render, staticRenderFns } from "./ComponentRefundExchangeAmount.vue?vue&type=template&id=72c960e6&scoped=true&"
import script from "./ComponentRefundExchangeAmount.vue?vue&type=script&lang=ts&"
export * from "./ComponentRefundExchangeAmount.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentRefundExchangeAmount.vue?vue&type=style&index=0&id=72c960e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c960e6",
  null
  
)

export default component.exports